export default __webpack_public_path__ + "static/media/652.243ce715.gif";